import useQuery from '../useQuery';

/** M31 (#517): the seller's per-carrier BYOCA connection status (USPS, UPS,
 * FedEx, DHL). Read-only public shape — never carries carrier secrets. Any
 * active member can read; the connect/disconnect mutations are Owner/Manager
 * only. Response: `{ carriers: [{ carrier, connected, external_account,
 * platform_fallback }], platform_default_enabled }`. Mirrors
 * `useShippingConnectionQuery` (same wrapper + status shape). */
function useCarrierConnectionsQuery(sellerId, params) {
  return useQuery(`/shipping/${sellerId}/carriers/`, {
    enabled: Boolean(sellerId),
    staleTime: 60 * 1000,
    ...params,
  });
}

export default useCarrierConnectionsQuery;
